import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'linked-alerts.services.actions.fetch-linked-alerts.error-title',
		defaultMessage: 'We could not load linked alerts',
		description: 'The title text in the status flag if linked alerts can not be fetched.',
	},
});
